export interface Progress {
    top: number
    center: number
    bottom: number
}

export type Step = {
    element: HTMLElement
    name: string
    progress: Progress
}

export type Steps = { [name: string]: Step }

type ScrollCallback = (
    steps: Steps,
    documentProgress: Progress,
) => void | Promise<void>

function computeProgress(currentElement: HTMLElement): Progress {
    const bounds = currentElement.getBoundingClientRect()

    const top = Math.max(
        Math.min((window.innerHeight - bounds.top) / window.innerHeight, 1),
        -1,
    )
    const bottom = Math.max(
        Math.min((window.innerHeight - bounds.bottom) / window.innerHeight, 1),
        -1,
    )
    const center = (top + bottom) / 2

    return {
        top,
        center,
        bottom,
    }
}

export class Scroll {
    private readonly steps: {
        element: HTMLElement
        name: string
    }[] = []

    private readonly callbacks: ScrollCallback[] = []

    constructor(private readonly top: HTMLElement) {}

    addStep(element: HTMLElement, name: string): void {
        this.steps.push({ element, name })
    }

    onChange(cb: ScrollCallback): void {
        this.callbacks.push(cb)
    }

    handleScroll(): void {
        const steps: Steps = {}

        for (const step of this.steps) {
            steps[step.name] = {
                element: step.element,
                name: step.name,
                progress: computeProgress(step.element),
            }
        }

        const documentProgress = computeProgress(this.top)

        for (const cb of this.callbacks) {
            cb(steps, documentProgress)
        }
    }
}
